module.exports = __webpack_public_path__ + "img/C08TechSilkWeaving_ua.e0b6b2c2.webp";